var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('common-header',{attrs:{"data":['home', 'applications', 'applicants', 'resolve']}}),_c('new-applicant-data'),_c('matched-applicant-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }